import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TransactionFacade } from '@symphony-solo/domain/transaction/src';

@Component({
  selector: 'symphony-solo-total-price-bar',
  templateUrl: './total-price-bar.component.html',
  styleUrls: ['./total-price-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TotalPriceBarComponent {
  public total$ = this.transactionFacade.totalPrice$;
  public currencyCode = 'GBP';

  constructor(private transactionFacade: TransactionFacade) {}
}
